import VideoResponser from './components/video/video-responser';

document.querySelectorAll('.js-responsive-video')?.forEach((video) => {
    new VideoResponser(video); // eslint-disable-line no-new
});
